import { AxiosResponse } from "axios";
import API from "../API";

export const groupMemberList = (id: string): Promise<AxiosResponse> =>
  API.get(`/group/member/list/${id}`);

export const groupChannelList = (id: string): Promise<AxiosResponse> =>
  API.get(`/group/channel/list/${id}`);

export const deactivateChannel = (
  groupId: string,
  channelId: string,
  active: boolean
): Promise<AxiosResponse> =>
  API.post(`/group/channel/manager/${groupId}/${channelId}`, {
    active,
  });

export const groupChannelHistory = (
  groupId: string,
  channelId: string
): Promise<AxiosResponse> =>
  API.get(`/group/channel/list/${groupId}?channelId=${channelId}`);

type ManageFamiliesCreatePayload = {
  address: string;
  city: string;
  state: string;
  zip: string;
  country: string;
  email: string;
  phoneNumber: string;
  creditCardTokenId: string;
  cardLast4?: string;
  cardBrand?: string;
  cardExpiryMonth?: number;
  cardExpiryYear?: number;
  cardName: string;
};

export const CreateGroupSetBillingInformationStep1 = (
  payload: ManageFamiliesCreatePayload
): Promise<AxiosResponse> => API.post("/group/billing/save", payload);

export const UpdateGroupSetBillingInformation = (
  id: string,
  payload: ManageFamiliesCreatePayload
): Promise<AxiosResponse> => API.put(`/group/billing/update/${id}`, payload);

type ManageFamiliesCreateStep2Payload = {
  coupons: string[];
  priceId: string;
  groupId: string;
  name: string;
};

export const CreateAssignSubscriptionStep2 = (
  payload: ManageFamiliesCreateStep2Payload
): Promise<AxiosResponse> =>
  API.post("/group/billing/assignSubscription", payload);

type ManageFamiliesUpdatePayload = {
  coupons: string[];
  priceId: string;
  groupId: string;
};

export const UpdateSubscription = (
  payload: ManageFamiliesUpdatePayload
): Promise<AxiosResponse> =>
  API.post("/group/billing/changeSubscription", payload);

type ManageFamiliesMemberAddCreateStep3Payload = {
  groupId: string;
  role: string;
  userId: string;
};

export const memberAddStep3 = (
  payload: ManageFamiliesMemberAddCreateStep3Payload
): Promise<AxiosResponse> => API.post("/group/member/add", payload);

type ManageFamiliesUserCreateStep3Payload = {
  name: string;
  email: string;
  subtype: string;
  groupId: string;
};

export const userCreateStep3 = (
  payload: ManageFamiliesUserCreateStep3Payload
): Promise<AxiosResponse> => API.post("/group/user/create", payload);

export const sync = (payload: any): Promise<AxiosResponse> =>
  API.post("/group/user/sync", payload);

export const DeactivateMember = (
  groupId: string,
  userId: string,
  active: boolean
): Promise<AxiosResponse> =>
  API.post(`/group/member/manager/${groupId}/${userId}`, { active });

export const ExportingChannel = (
  channelId: string,
  email: string
): Promise<AxiosResponse> =>
  API.post(`/group/channels/export/request/${channelId}`, { email });

export const EditNameGroup = (
  groupId: string,
  name: string
): Promise<AxiosResponse> => API.put(`/group/edit/${groupId}`, { name });

type PayloadEditMemberFamily = {
  groupId: string;
  userId: string;
  email: string;
  name: string;
  subtype: string;
};

export const editMemberFamily = (
  payload: PayloadEditMemberFamily
): Promise<AxiosResponse> =>
  API.put(`group/user/edit/${payload.userId}`, payload);
